<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2">

        <div style="position: relative; z-index: 1">
          <div class="d-flex" style="position: absolute">
            <filtro-tarifas-de-lineas />
          </div>
        </div>

        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 110px"
          v-if="loadingTable"
        >
          <Loading />
        </div >
        <div v-else class="w-100 text-center">
          <new-data-table
            customHeaders
            v-if="dataTableAux.length > 0"
            :headers="headers"
            :data="dataTableAux"
            :acciones="actions"
            :max="10"
            :seleccionar="getSelectedRow"
            paginacion
            buscar
            numerador
            idtabla="lista_tarifas_lineas"
          />

          <not-found-table
            v-else
            class="justify-content-center w-100 pt-5"
            :text="'No se encontraron registros de tarifas líneas'"
          />
        </div> 
        
      </div>
    </div>

    <detalle-recargos-tarifas :id="tariff_line_id" :version="2"></detalle-recargos-tarifas>

  </div>
</template>
<script>
import Vue from "vue";

import { mapActions, mapState } from "vuex";

// Componentes
import NewDataTable from "../../common/NewDataTable";
import Loading from "../../common/loading";
import FiltroTarifasDeLineas from "../../filtros/lineas/tarifas/FiltroTarifasDeLineas";

import NotFoundTable from "../../../components/common/NotFoundTable";

// Toast
import VueToastify from "vue-toastify";
import DetalleRecargosTarifas from "@/components/modals/lineas/tarifas/detalle_recargos/DetalleRecargosTarifas.vue";

Vue.use(VueToastify);

export default {
  props: {
    data: { type: Array },
  },
  data() {
    return {
      headers: [
        { title: "Naviera", width: "10px" },
        { title: "Naviera Salida", width: "10px" },
        { title: "POL", width: "15px" },
        { title: "POD", width: "15px" },
        { title: "Desde", width: "40px" },
        { title: "Hasta", width: "40px" },
        { title: "TT", width: "10px" },
        { title: "Pública (Venta)", width: "40px" },
        { title: "Contenedor", width: "40px" },
        { title: "Producto", width: "40px" },
        { title: "Atmósfera", width: "40px" },
        { title: "Trat. frío", width: "40px" },
        { title: "Dias Libres Origen", width: "20px" },
        { title: "Dias Plug Origen", width: "20px" },
        { title: "Dias Libres Destino", width: "20px" },
        { title: "Dias Plug Destino", width: "20px" },
        { title: "Genset", width: "5px" },
        { title: "Get Out", width: "5px" },
        { title: "Comentarios", width: "200px" },
        { title: "Contrato - Número", width: "70px" },
        { title: "Acciones", width: "70px" },
      ],
      actions: [],
      dataTableAux: this.data,
      tariff_line_id: 0,
    };
  },
  components: {
    DetalleRecargosTarifas,
    NewDataTable,
    Loading,
    FiltroTarifasDeLineas,
    NotFoundTable,
  },
  computed: {
    ...mapState(["loadingTable"]),
  },
  methods: {

    ...mapActions("lineas", ["actionsSetShowModalTariffLinesRecharges"]),

    async generateActionsButtons() {

      this.actions = [];

      this.dataTableAux.map((item, index) => {

        this.actions.push([
          {
            icon: "fa fa-dollar-sign",
            title: "Ver Recargos Asociados",
            id: index,
            item
          }
        ]);

      });

    },
    async getSelectedRow(row) {

      switch (row.accion) {

        case "Ver Recargos Asociados":

          console.log("aaaa");

          this.actionsSetShowModalTariffLinesRecharges(true);

          this.tariff_line_id = this.data[row.id].data_complementaria.id;

          break;
      }

    }
  },

  watch: {
    data: function (_new) {

      if (_new) {

        this.dataTableAux = _new;

        this.generateActionsButtons();
      }

    },

  },
};
</script>

<style></style>
